<template>
  <div id="project-form">
    <!-- Card-01 -->
    <b-card>
      <!-- Card-01 > 타이틀 영역 START-->
      <div class="title-wrap">
        <span v-if="!isNew" class="project-id">{{ project.projectId }}</span>
        <b-form-row class="align-items-center" style="gap: 2rem; margin-left: 0; margin-right: 0;">
          <!-- Card-01 > Form > Form-row1 > Project ID(New) START -->
          <div v-if="isNew" class="input-wrap border-bottom">
            <!-- <label for="projectId">Project ID<span class="required">*</span></label> -->
            <b-form-group class="mb-0">
              <b-form-input id="projectId" name="projectId" type="text" placeholder="Project ID"
                v-model="project.projectId" v-validate="{ required: true }" :disabled="idExists"
                :state="validateState('projectId')" class="custom-input"></b-form-input>
              <b-form-invalid-feedback id="projectId-feedback">
                {{ errors.first('projectId') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <!-- Card-01 > Form > Form-row1 > Project ID(New) END -->
          <div class="input-wrap border-bottom title">
            <b-input-group>
              <b-form-input name="title" label="Title" id="title" placeholder="Enter Project Name" size="xl"
                class="my-0" style="height: 66px; font-size: 30px;" v-model="project.name" ref="title"
                v-validate="{ required: true }" :state="validateState('title')"></b-form-input>
            </b-input-group>
          </div>
        </b-form-row>
      </div>
      <!-- Card-01 > 타이틀 영역 END-->
      <!-- Card-01 > Form 영역[ Project ID(New), Description(New, Detail), Duration(New, Detail)] START -->
      <div class="project-form-wrap" v-if="project">
        <!-- Card-01 > Form > Form-row2 > Duration(New, Detail) / Project Status START -->
        <div class="left-form-area">
          <div class="input-wrap">
            <label for="">Project Status</label>
            <b-dropdown right :text="getTextOfOptions(project.status)" size="lg" class="btn-select-status"
              :disabled="isNew" :class="getStatusClass(project.status)">
              <b-dropdown-item v-for="option in projectStatusOptions" :key="option.value" :value="option.value"
                @click="project.status = option.value">{{ option.text }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="input-wrap">
            <label for="start-date">Start - End Date</label>
            <div class="date-wrap">
              <b-form-group>
                <b-input-group class="form-inline">
                  <b-form-input id="start-date" name="start-date" type="date" v-model="project.startDate"
                    v-validate="dateRule" class="custom-input  rounded" data-vv-as="start date" placeholder="YYYY-MM-DD"
                    :state="validateState('start-date')"></b-form-input>
                  <b-form-invalid-feedback id="start-date-feedback">
                    {{ errors.first('start-date') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-input-group class="form-inline">
                  <b-form-input id="end-date" name="end-date" type="date" v-model="project.endDate"
                    v-validate="dateRule" class="custom-input  rounded" data-vv-as="end date" placeholder="YYYY-MM-DD"
                    :state="validateState('end-date')"></b-form-input>
                  <b-form-invalid-feedback id="end-date-feedback">
                    {{ errors.first('end-date') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>
        <!-- Card-01 > Form > Form-row2 > Duration(New, Detail) / Project Status END -->
        <!-- Card-01 > Form > Form-row3 > Description(New,Detail) START -->
        <div class="right-form-area">
          <div>
            <label for="description">Description</label>
            <b-form-textarea class="description" id="description" name="description" placeholder="Enter the description"
              v-model="project.description" rows="5" style="height: 139px;"></b-form-textarea>
            <b-form-invalid-feedback id="description-feedback">
              {{ errors.first('description') }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <!-- Card-01 > Form > Form-row3 > Description(New,Detail) END -->
      </div>
    </b-card>

    <!-- Card-02 > Period / Members / Config -->
    <b-card no-body class="project-tab-card">
      <b-row class="file-input-area">
        <b-col cols="7">
          <b-form-group label-for="file-input" class="new-file-label h-100">
            <b-form-file ref="file-input" id="file-input" name="file" v-model="importDevMethodologyFile"
              placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"
              class="new-file-input h-100"></b-form-file>
          </b-form-group>
        </b-col>
        <b-col class="import-button-area" cols="5">
          <base-button style="background-color: #168D4C;" size="sm" @click="importDevMethodology"
            :disabled="importButtonIsDisabled">Import</base-button>
          <base-button style="background-color: #168D4C;" size="sm" @click="exportDevMethodology">Export</base-button>
          <base-button style="background-color: #168D4C; margin-left:1em" size="sm"
            @click="downloadDevMethodologyTemplate">Template</base-button>
          <!-- <b-button :disabled="importButtonIsDisabled" @click="importDevMethodology" size="md">
            Import
          </b-button>
          <b-button @click="exportDevMethodology" size="md">
            Export
          </b-button>
          <b-button @click="downloadDevMethodologyTemplate" size="md">
            Template
          </b-button> -->
        </b-col>
      </b-row>

      <b-tabs card>
        <b-tab title="Config" active>
          <b-table :items="project.config" :fields="configTableFields" head-variant="light" responsive fixed
            tbody-tr-class="config-row" class="mb-0 table-wrap project-config-table" hover outlineless borderless>
            <template v-slot:cell(visible)="data">
              <b-form-checkbox :checked="data.item.isVisible" :disabled="data.item.option === 'type'"
                @change="isVisibleClicked(data.item)" />
            </template>
            <template v-slot:cell(option)="data">
              {{ getConfigOptionLabel(data.item) }}
            </template>
            <template v-slot:cell(isMandatory)="data">
              <b-form-checkbox :checked="data.item.isMandatory" @change="isMandatoryClicked(data.item)"
                :disabled="data.item.option === 'type' || !data.item.isVisible" />
            </template>
            <template v-slot:cell(addItems)="data">
              <b-input-group class="add-item-input-group"
                v-if="data.item.option != 'priority' && data.item.option != 'level' && data.item.option != 'result' && data.item.option != 'type' && data.item.option != 'requirementId'">
                <b-form-input placeholder="Add Item" v-model="configInput[data.item.option]"
                  :disabled="!data.item.isVisible" />
                <b-button class="add-item-button" @click="onConfigItemAdd(data.item)"
                  :disabled="isOptionItemAddButtonDisable(data.item)">Add</b-button>
              </b-input-group>
            </template>
            <template v-slot:cell(items)="data">
              <div class="config-option-items">
                <!-- option item 중 default item이면 삭제 불가, 아니면 삭제 버튼 보임 -->
                <div v-for="(item, idx) in getOptionItems(data.item)" :key="idx"
                  :class="isDefaultConfigItem(data.item, item) ? 'config-option-item-default' : 'config-option-item'">
                  {{ item }} <i class="bi bi-x" v-if="!isDefaultConfigItem(data.item, item)"
                    @click="deleteConfigOpionItem(data.item, item)" style="cursor:pointer"></i> </div>
              </div>
            </template>
          </b-table>
        </b-tab>
        <!-- Card-02 > Period 탭메뉴 START - 기존 methodology를 Period로 이동 -->
        <b-tab title="Timeline">
          <loading :active.sync="loading"></loading>
          <!-- Member management -->
          <div>
            <div v-if="this.devMethodologyDetail && this.devMethodologyDetail.length > 0">
              <ChtterMethodologyManagementGrid ref="devMethodologyGrid"
                :propMethodologyDetail="this.devMethodologyDetail" :propMembers="project.assignedUsers" />
            </div>
            <div class="timeline-empty" v-else>
              No timeline has been setup.
            </div>
          </div>
          <!-- /Member management -->
        </b-tab>
        <!-- Card-02 > Period 탭메뉴 END -->
        <!-- Card-02 > Members 탭메뉴 START - 기존 roles, users, members를 Member로 이동 -->
        <b-tab title="Members">
          <div>
            <!-- Card-02 > Members > Roles START -->
            <b-form-tags id="tags-with-dropdown" v-model="project.roles" no-outer-focus class="mb-0 roles-wrap">
              <template v-slot="{ tags, disabled, addTag, removeTag, inputHandlers }">
                <b-dropdown variant="black" block menu-class="w-100" no-caret>
                  <template #button-content>
                    <span class="icon plus"></span>
                    Add Role
                  </template>
                  <b-dropdown-form @submit.stop.prevent="() => { }">
                    <b-form-group label-for="tag-search-input" label-cols-md="auto" label-size="sm"
                      :description="searchDesc" :disabled="disabled">
                      <b-form-input v-model="search" id="tag-search-input" type="search" size="sm" v-on="inputHandlers"
                        autocomplete="off" @keyup.enter="search = ''" placeholder="Search Roles"></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button v-for="option in availableOptions" :key="option"
                    @click="onOptionClick({ option, addTag })">
                    {{ option }}
                  </b-dropdown-item-button>
                </b-dropdown>
                <div v-if="tags.length > 0" class="tag-list">
                  <b-form-tag v-for="tag in tags" @remove="removeTag(tag)" :key="tag" :title="tag"
                    style="display: inline-flex; align-items: center; flex: 0 0 auto;">
                    {{ tag }}
                  </b-form-tag>
                </div>
              </template>
            </b-form-tags>
            <!-- Card-02 > Members > Roles END -->
            <div class="members-wrap">
              <!-- Card-02 > Members > Users START -->
              <div class="members-content users">
                <div class="title">User</div>
                <chatter-project-available-user-grid v-if="loaded" ref="prjAvailMemberGrid"
                  @moveFromAvailableToMembers="moveFromAvailableToMembers" :propItems="sortedAvailableUsers" />
              </div>
              <!-- Card-02 > Members > Users END -->
              <!-- Card-02 > Members > Member START -->
              <div class="members-content members">
                <div class="title">Member</div>
                <chatter-project-member-grid v-if="loaded" ref="prjAssignedMemberGrid"
                  @moveToAvailableFromMembers="moveToAvailableFromMembers" :propItems="assignedUsers"
                  :propRoleOptions="project.roles" />
              </div>
              <!-- Card-02 > Members > Member END -->
            </div>
          </div>
        </b-tab>
        <!-- Card-02 > Members 탭메뉴 END -->
        <!-- Card-02 > Config 탭메뉴 START - 해당 영역은 정의 예정이라 미작업 -->

        <!-- Card-02 > Config 탭메뉴 END -->
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import ChatterProjectMemberGrid from "@/components/chatter/project/ChatterProjectMemberGrid.vue";
import ChatterProjectAvailableUserGrid from "@/components/chatter/project/ChatterProjectAvailableUserGrid.vue";
import ChtterMethodologyManagementGrid from "@/components/chatter/project/ChtterMethodologyManagementGrid.vue";
import importJson from './model/methodology.json'
import employeeIcon from "@/components/chatter/icons/employeeIcon.vue";
import BaseButton from "@/components/chatter/requirement/BaseButton.vue";
import { componentsPlugin } from 'bootstrap-vue';

const data = importJson;
export default ({
  props: ['id', 'title'],
  components: { ChtterMethodologyManagementGrid, ChatterProjectMemberGrid, ChatterProjectAvailableUserGrid, employeeIcon, BaseButton },
  mounted() {
    this.$emit('load');
  },
  created() {
    this.options = ['PM', 'PL', 'PMO', 'Developer', 'BA', 'TA'];
  },
  computed: {
    isNew() {
      return this.id == -1;
    },
    importButtonIsDisabled() {
      return !this.importDevMethodologyFile;
    },
    methodologyOptions() {
      return data.map(obj => obj.type);
    },
    projectStatusOptions() {
      return this.$store.getters['chatter/projectStatusOptions'].filter(obj => obj.value !== '')
    },
    tenantId() {
      return this.$store.getters["auth/currentUser"].tenant;
    },
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase()
    },
    availableOptions() {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.options.filter(opt => this.project.roles.indexOf(opt) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.toLowerCase().indexOf(criteria) > -1);
      }
      // Show all options available
      return options
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return 'There are no tags matching your search criteria'
      }
      return ''
    },
    allProjectInfo() {
      return this.$store.getters['chatter/getAllProjectInfo'];
    },
    typeOptions() {
      return this.$store.getters['chatter/typeOptions']
    },
    sortedAvailableUsers() {
      return this.project.availableUsers.sort((a, b) => a.userName.localeCompare(b.userName));
    },
    changeConfig() {
      console.log('config 변경검사');
      // if(!this.prevProjectState) return false;
      const prevConfigCopy = JSON.parse(JSON.stringify(this.prevConfigState));
      const currentConfigCopy = JSON.parse(JSON.stringify(this.project.config));
      for(let i = 0; i < currentConfigCopy.length; i++) {
        prevConfigCopy[i].items.sort((a, b) => a.localeCompare(b));
        currentConfigCopy[i].items.sort((a, b) => a.localeCompare(b));
      }

      return JSON.stringify(prevConfigCopy) !== JSON.stringify(currentConfigCopy);
    },
    changeAssignedUsers() {
      console.log('config assignedUsers 변경검사');
      // if(!this.prevProjectState) return false;
      const prevAssignedUsersCopy = JSON.parse(JSON.stringify(this.prevAssignedUsersState));
      const currentAssignedUsersCopy = JSON.parse(JSON.stringify(this.assignedUsers));

      if (prevAssignedUsersCopy.length !== currentAssignedUsersCopy.length) {
        return true;
      }

      prevAssignedUsersCopy.sort((a, b) => a.userId.localeCompare(b.userId));
      currentAssignedUsersCopy.sort((a, b) => a.userId.localeCompare(b.userId));

      // 추가되거나 업데이트된 것들 감지
      for (let i = 0; i < currentAssignedUsersCopy.length; i++) {
        const targetUser = currentAssignedUsersCopy[i];
        const findUser = prevAssignedUsersCopy.find(prevUser => prevUser.userId === targetUser.userId);

        // 기존상태에서 못 찾으면 새로 추가된 사용자
        if(!findUser) return true;

        const compareFields = ['role', 'admin', 'roleIn', 'roleOut', 'engagementRate'];
        // 속성 비교 (role, admin, roleIn, roleOut, engagementRate)

        for (let j = 0; j < compareFields.length; j++) {
          const compareField = compareFields[j];
          if (targetUser[compareField] !== findUser[compareField]) {
            return true;
          }
        }
      }

      // 삭제된 것 감지
      for (let i = 0; i < prevAssignedUsersCopy.length; i++) {
        const targetUser = prevAssignedUsersCopy[i];
        const findUser = currentAssignedUsersCopy.find(currUser => currUser.userId === targetUser.userId);

        // 못찾으면 삭제된 사용자
        if (!findUser) return true;
      }
      return false;
    },
    changeProjectInfo() {
      // if(!this.prevProjectState) return false;
      console.log("프로젝트 변경");
      const compareFields = ['projectId', 'name', 'status', 'description', 'startDate', 'endDate']

      for (let j = 0; j < compareFields.length; j++) {
        const compareField = compareFields[j];
        if (this.prevProjectState[compareField] !== this.project[compareField]) {
          return true;
        }
      }

      const prevProjectRolesCopy = JSON.parse(JSON.stringify(this.prevProjectState.roles));
      const currProjectRolesCopy = JSON.parse(JSON.stringify(this.project.roles));

      if (prevProjectRolesCopy.length !== currProjectRolesCopy.length) {
        
        return true;
      }

      prevProjectRolesCopy.sort((a, b) => a.localeCompare(b));
      currProjectRolesCopy.sort((a, b) => a.localeCompare(b));

      for(let i = 0; i < prevProjectRolesCopy.length; i++) {
        if(prevProjectRolesCopy[i] !== currProjectRolesCopy[i]) {
          return true;
        }
      }

      return false;
    },

    isChangedForm() {
      if(!this.loaded) {
        return false;
      } else {
        return this.changeConfig || this.changeAssignedUsers || this.changeProjectInfo;
      }
    }
  },
  data() {
    return {
      loading: false,
      dummyMethodologyData: [],
      curTab: null,
      options: [],
      search: '',
      value: [],
      loaded: false,
      devMethodologyList: [],
      prevProjectState: '',
      prevConfigState: '',
      prevAssignedUsersState: '',
      assignedUsers: [],
      project: {
        projectId: '',
        name: '',
        description: '',
        startDate: '',
        endDate: '',
        creatorId: '',
        status: 'OPEN',
        availableUsers: [],
        checkedMethodology: false,
        roles: [],
        //project New에서도 설정할 수 있도록 미리 세팅하는 값
        config: [
          {
            option: 'type',
            isVisible: true,
            isMandatory: true,
            items: ['Task', 'Issue', 'Risk', 'Bug', 'Inquiry', 'Requirement']
          },
          {
            option: 'requirementId',
            isVisible: true,
            isMandatory: true,
            items: []
          },
          {
            option: 'priority',
            isVisible: false,
            isMandatory: false,
            items: ['High', 'Medium', 'Low']
          },
          {
            option: 'level',
            isVisible: false,
            isMandatory: false,
            items: ['Critical', 'Major', 'Minor', 'Trivial']
          },
          {
            option: 'result',
            isVisible: false,
            isMandatory: false,
            items: ['Success', 'Fail']
          },
          {
            option: 'importance',
            isVisible: false,
            isMandatory: false,
            items: ['High', 'Medium', 'Low']
          },
          {
            option: 'system',
            isVisible: false,
            isMandatory: false,
            items: []
          },
          {
            option: 'businessCategory',
            isVisible: false,
            isMandatory: false,
            items: []
          },
          {
            option: 'job',
            isVisible: false,
            isMandatory: false,
            items: [
              '기획',
              '디자인',
              'Publishing',
              '설계',
              'Front End',
              'Back End',
              'Database',
              'Batch',
              'Interface',
              '문서 작성',
              '기타'
            ]
          }
        ],
      },
      devMethodologyDetail: [],
      dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
      blContentModified: false,
      idExists: false,
      methodologyTempByType: '',
      isCardFold:
      {
        title: false,
        role: false,
        user: true,
        member: true,
        methodology: true,
      },
      importDevMethodologyFile: null,
      // configOptions: [], project안으로 이동
      configTableFields: [
        {
          key: 'visible',
          label: 'Visible',
          thClass: ['text-center'],
          class: ['text-center', 'align-middle', 'columnRate10'],
        },
        {

          key: 'option',
          label: 'Option',
          thClass: ['text-center'],
          class: ['text-center', 'align-middle', 'columnRate13'],
        },
        {

          key: 'isMandatory',
          label: 'Mandatory',
          thClass: ['text-center'],
          class: ['text-center', 'align-middle', 'columnRate11'],
        },
        {
          key: 'addItems',
          label: 'Add Items',
          thClass: ['text-center'],
          class: ['text-center', 'align-middle', 'columnRate20'],
        },
        {
          key: 'items',
          label: 'Option Items',
          thClass: ['text-center'],
          class: ['text-center', 'align-middle', 'columnRate46'],
        },
      ],
      //현재 project config 관련 사용자가 입력한 값(add item)
      configInput: {},
      //현재 project의 config 관련 default 정보(이름, 필수 값들)
      configDefaultInfo: [
        {
          option: 'type',
          label: 'Type',
          items: ['Task', 'Issue', 'Risk', 'Bug', 'Inquiry', 'Archive']
        },
        {
          option: 'requirementId',
          label: 'Requirement',
          items: []
        },
        {
          option: 'priority',
          label: 'Priority',
          items: ['High', 'Medium', 'Low']
        },
        {
          option: 'level',
          label: 'Level',
          items: ['Critical', 'Major', 'Minor', 'Trivial']
        },
        {
          option: 'result',
          label: 'Result',
          items: ['Success', 'Fail']
        },
        {
          option: 'importance',
          label: 'Importance',
          items: []
        },
        {
          option: 'system',
          label: 'System',
          items: []
        },
        {
          option: 'businessCategory',
          label: 'Business Category',
          items: []
        },
        {
          option: 'job',
          label: 'Work Category',
          items: []
        }
      ],
    }
  },
  watch: {
    project: {
      handler() {
        this.blContentModified = true;
      },
      deep: true,
    },
    'methodologyTempByType': {
      handler() {
        if (this.methodologyTempByType != '') {
          data.filter(methodology => methodology.type === this.methodologyTempByType)[0].detail.forEach(obj =>
            this.devMethodologyDetail.push(obj)
          )
        }
      }
    },
    isChangedForm(newValue) {
      this.$emit('isChangedForm', newValue);
    },
    deep: false,
  },
  methods: {
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async load() {
      this.loaded = false;
      if (this.id !== -1) {
        // Load Project
        let response = await axios.post('chatter/retrieveProject/' + this.id, {}, {
          headers: { Authorization: accessToken() }
        });
        const defaultConfig = this.project.config;
        this.project = response.data;
        //Config Option 기능 전에 생성된 프로젝트인 경우에는 default Config가 보이도록 함
        if (response.data.config.length === 0) {
          this.project.config = defaultConfig;
        }

        this.idExists = true;
        this.$emit("set-chat", this.project);
        await this.retrieveAssignedUserInfo();
        await this.retrieveDevMethodology();
      } else {
        // 신규건이면
        // 생성하려는 사용자를 기본으로 assigne

        const currentUserId = this.currentUserId();
        const currentUserName = this.userName();

        const defaultAssignedUser = {
          projectId: null,
          userId: currentUserId,
          userName: currentUserName,
          engagementRate: 100,
          role: 'Member',
          expand: false,
          selected: false,
        }
        
        this.assignedUsers = [defaultAssignedUser];
        this.prevAssignedUsersState = JSON.parse(JSON.stringify(this.assignedUsers));
        this.project.roles = ['Member'];
      }

      this.prevConfigState = JSON.parse(JSON.stringify(this.project.config));
      this.prevProjectState = JSON.parse(JSON.stringify(this.project))
      await this.retrieveAvailableUserInfo();
      this.loaded = true;
    },
    async submit() {
      //Config Option Validation Check
      let validated = this.validateConfigOption();
      if (!validated) return Promise.reject(new Error('400'));

      let result = await this.$validator.validate();
      if (!result) return Promise.reject(new Error('400'));

      // Create formData
      // let data = new FormData();
      // // let status = '';

      // data.append('projectId', this.project.projectId);
      // data.append('name', this.project.name);
      // data.append('startDate', this.project.startDate);
      // data.append('endDate', this.project.endDate);
      // data.append('creatorId', this.project.creatorId);
      // data.append('status', this.project.status);
      // data.append('description', this.project.description);
      // data.append('projectType', this.project.checkedMethodology);
      // data.append('roles', this.project.roles);
      // Get members and admins from projectMemberManagement component

      const members = this.assignedUsers.map(member => {
        return {
          ...member,
          projectId: this.project.projectId,
          engagementRate: member.engagementRate / 100,
        }
      })
      //Config Option 중에 type은 불변객체 형태이므로 따로 처리해줌
      this.project.config.find(config => config.option === 'type').items = this.typeOptions.map(item => item.value).filter(value => value != '');

      const data = {
        projectId: this.project.projectId,
        name: this.project.name,
        startDate: this.project.startDate,
        endDate: this.project.endDate,
        status: this.project.status,
        description: this.project.description,
        roles: this.project.roles,
        users: members,
        config: this.project.config
      }
      // Submit a new chat
      const response = await axios.post('chatter/createProject',
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken()
          }
        });

      return response.data;
    },
    getTextOfOptions(status) {
      // statusOptions 배열에서 status 값과 value가 같은 객체 찾기
      const matchedOption = this.projectStatusOptions.find(option => option.value === status);
      // 찾은 객체가 있으면 해당 객체의 text 값을 반환하고, 없으면 빈 문자열 반환
      return matchedOption ? matchedOption.text : '';
    },
    getStatusClass(status) {
      if (status == 'OPEN') return 'open'
      else if (status == 'CLOSED') return 'closed'

    },
    async update() {
      //Config Option Validation Check
      let validated = this.validateConfigOption();
      if (!validated) return Promise.reject(new Error('400'));

      let result = await this.$validator.validate();
      if (!result) return Promise.reject(new Error('400'));

      if(this.assignedUsers.length < 1) {
        return Promise.reject(new Error('최소 한명의 멤버가 등록되어야 합니다.'));
      }
      const members = this.assignedUsers.map(member => {
        return {
          ...member,
          projectId: this.project.projectId,
          engagementRate: member.engagementRate / 100,
        }
      })

      const data = {
        projectId: this.project.projectId,
        name: this.project.name,
        startDate: this.project.startDate,
        endDate: this.project.endDate,
        status: this.project.status,
        description: this.project.description,
        roles: this.project.roles,
        users: members,
        config: this.project.config
      }

      // Update the Project
      const response = await axios.post('chatter/updateProject',
        data,
        {
          headers: {
            Accept: 'application/json',
            Authorization: accessToken()
          }
        });
      
      return response.data;
    },
    async delete() {
      // Create formData
      let data = new FormData();
      data.append('projectId', this.project.projectId);
      data.append('name', this.project.name);
      data.append('startDate', this.project.startDate);
      data.append('endDate', this.project.endDate);
      data.append('creatorId', this.project.creatorId);
      data.append('status', this.project.status);
      data.append('description', this.project.description);
      data.append('roles', this.project.roles);

      // Update the chat
      try {
        await axios.post('chatter/deleteChatterProject',
          data,
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data',
              Authorization: accessToken()
            }
          });
      } catch (error) {
        this.showError(error.message);
      }
    },

    onOptionClick({ option, addTag }) {
      addTag(option)
      this.search = ''
    },
    moveFromAvailableToMembers(selected) {
      // member 등록
      this.curTab = 1;
      selected = selected.map((item) => ({
        ...item,
        engagementRate: 100,
        expand: false,
        selected: false
      }));
      // this.project.assignedUsers = [...this.project.assignedUsers, ...selected];

      for (let selectedItem of selected) {
        // members에 존재하지 않으면 추가
        let isExists = this.assignedUsers.some(item => item.userId === selectedItem.userId);
        if (!isExists) {
          this.assignedUsers.push(selectedItem);
        }

        // members에 추가한 user available에서 삭제
        const idx = this.project.availableUsers.findIndex(item => item.userId === selectedItem.userId);
        if (idx !== -1) {
          this.project.availableUsers.splice(idx, 1);
        }
      }

      // available users에서 members[assigned user]로 빠진 user들을 제외하고 화면에 뿌려주는게 필요함.
      // this.project.availableUsers = this.project.availableUsers.filter(user => {
      //   return !selected.some(assignedUser => assignedUser.userId === user.userId);
      // });

    },
    moveToAvailableFromMembers(selectedUser) {
      // member 제거
      this.curTab = 0;

      // 24-06-12 프로젝트 생성 시 기본멤버에 대해 unassign 제약
      if (this.isNew) {
        const currentUserId = this.currentUserId();

        if (selectedUser.userId === currentUserId) {
          // TOAST 메세지 출력
          this.showToast('프로젝트 기본 멤버입니다.', 'danger');

          return;
        }
      }
      this.project.availableUsers.push(selectedUser);

      const idx = this.assignedUsers.findIndex(item => item.userId === selectedUser.userId);
      if (idx !== -1) {
        this.assignedUsers.splice(idx, 1);
      }
    },
    async retrieveAssignedUserInfo() {
      let response = await axios.get('chatter/project/retrieveProjectUser', {
        headers: { Accept: 'application/json', Authorization: accessToken() },
        params: { projectId: this.id }
      });

      this.assignedUsers = response.data.map((user) => ({
        ...user,
        engagementRate: user.engagementRate * 100
      }));
      this.prevAssignedUsersState = JSON.parse(JSON.stringify(this.assignedUsers));
      if (this.assignedUsers) {
        this.curTab = 1;
      }
    },
    async retrieveAvailableUserInfo() {
      let response = await axios.get('chatter/retrieveChattererList', {
        params: {},
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      });
      // let users = response.data.slice(1).sort(this.compareUser);

      let users = response.data;
      users = users.filter(user => {
        return !this.assignedUsers.some(assignedUser => assignedUser.userId === user.userId);
      });
      // Add additional fields
      this.project.availableUsers = users.map((user) => ({
        ...user,
        projectId: this.id !== 1 ? this.id : null,
        // tenantId: this.tenantId,
        role: null
      }))
    },

    // 2023-12-04 devMethodology의 계층적 조회 API가 구현 될 때 까지 주석 후 임시 API 사용
    async retrieveDevMethodology() {
      // if (this.project.projectId || this.project.projectId === '') return;
      let response = await axios.get('chatter/retrieveDevMethodology/' + this.project.projectId, {
        params: {},
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      }
      )
      this.devMethodologyDetail = response.data;
    },

    async clear() {
      let confirmed = await this.$bvModal.msgBoxConfirm("초기화 하시겠습니까?", { title: "Confirm" });
      if (!confirmed) return;
      this.devMethodologyDetail.splice(0);
      this.methodologyTempByType = ''

    },
    handleCardFold(ref) {
      this.isCardFold[ref] = !this.isCardFold[ref];
    },
    importDevMethodology() {
      // 파일정보 가져오기
      // 파일이 없으면 메세지 출력 후 리턴
      if (!this.importDevMethodologyFile) {
        this.$bvToast.toast("임포트할 파일을 올려주세요.", {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 4000,
          variant: "danger"
        });

        return;
      }

      // 임포트 API 호출 후 
      const importData = new FormData()
      importData.append("file", this.importDevMethodologyFile);

      try {
        this.loading = true;
        axios.post('chatter/import/projectSetup/' + this.project.projectId,
          importData,
          {
            headers: {
              'Authorization': accessToken()
            }
          }
        ).then(response => {
          if (response.data.debugInfo) {
            this.$bvToast.toast(response.data.message, {
              title: `Notification`,
              toaster: "b-toaster-bottom-center",
              solid: true,
              appendToast: false,
              autoHideDelay: 4000,
              variant: "danger"
            });
          } else {
            this.importDevMethodologyFile = null;
            // devMethodology 다시 조회
            this.retrieveDevMethodology();
            this.retrieveAssignedUserInfo();
          }
        });
      } catch (e) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    exportDevMethodology() {
      // 프로젝트 ID로 API 요청
      try {
        this.loading = true;
        axios.get("chatter/export/projectSetup/" + this.project.projectId, {
          responseType: 'blob',
          headers: { Authorization: accessToken() }
        }).then(response => {

          if (response.status === 200) {
            const url = URL.createObjectURL(response.data)

            const link = document.createElement('a');
            if (url) {
              link.href = url;
              link.download = `${this.project.projectId}-setup.xlsx`;
              link.click();
            }
          }
        })
      } catch (e) {
        this.loading = false;
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    downloadDevMethodologyTemplate() {
      try {
        axios.get("chatter/download/template/project-setup-template.xlsx", {
          responseType: 'blob',
          headers: { Authorization: accessToken() }
        }).then(response => {
          if (response.status === 200) {
            const url = URL.createObjectURL(response.data)

            const link = document.createElement('a');
            if (url) {
              link.href = url;
              link.download = `project-setup-template.xlsx`;
              link.click();
            }
          }
        })
      } catch (e) {
        console.log(e);
      }
    },
    isMandatoryClicked(data) {
      const prevIsMandatory = this.project.config.find(config => config.option === data.option).isMandatory;
      this.project.config.find(config => config.option === data.option).isMandatory = !prevIsMandatory;
    },
    onConfigItemAdd(data) {
      //기존 Config Item 요소들 -> 소문자로 변경(Item 대/소문자 구분 없이 중복 제거하기 위함)
      const prevConfigItems = this.project.config.find(config => config.option === data.option).items.map(item => item.toLowerCase());
      //입력한 값이 이미 존재하지 않고, 입력 값이 공백이 아닌지 확인
      if (!prevConfigItems.includes(this.configInput[data.option].toLowerCase()) && this.configInput[data.option]) {
        //입력 값 items에 추가
        this.project.config.find(config => config.option === data.option).items.push(this.configInput[data.option]);
        //deep copy (화면 렌더링 되도록 하기 위함)
        this.project.config = JSON.parse(JSON.stringify(this.project.config));
      }
    },
    isVisibleClicked(data) {
      const prevIsVisible = this.project.config.find(config => config.option === data.option).isVisible;
      //isVisible 해제하면 isMandatory도 해제되도록
      if (prevIsVisible === true) {
        this.project.config.find(config => config.option === data.option).isMandatory = false;
      }
      this.project.config.find(config => config.option === data.option).isVisible = !prevIsVisible;
    },
    isDefaultConfigItem(data, item) {
      return this.configDefaultInfo.find(config => config.option === data.option) ? this.configDefaultInfo.find(config => config.option === data.option).items.includes(item) : false;
    },
    deleteConfigOpionItem(data, item) {
      this.project.config.find(config => config.option === data.option).items = this.project.config.find(config => config.option === data.option).items.filter(itm => itm != item);
    },
    getConfigOptionLabel(data) {
      return this.configDefaultInfo.find(config => config.option === data.option).label;
    },
    isOptionItemAddButtonDisable(data) {
      if (data.isVisible) {
        //입력된 값이 없으면
        if (this.configInput[data.option] === '' || this.configInput[data.option] === undefined) {
          return true;
        }
        return false;
      }
      else {
        return true;
      }
    },
    //Config에서 Option Items 테이블에 출력할 때, v-if와 v-for문을 동시에 사용하는 것 대신에 method로 items를 필터링해서 v-if문을 안 쓰고 출력하기 위함
    getOptionItems(data) {
      //type은 불변객체형태로 사용되고 있으므로 따로 처리함
      if (data.option === 'type') {
        return this.typeOptions.map(option => option.text).filter(option => option != ' ');
      }
      else {
        return data.items;
      }
    },
    validateConfigOption() {
      //Config Option 중 Create/Update 할 조건이 만족되었는지 확인(ex. Option Item이 없는데 isVisible이면 Create/Update 불가)
      for (let option of this.project.config) {
        if (option.isVisible === true) {
          if (option.items.length === 0 && option.option != 'requirementId') {
            this.$bvToast.toast('선택한 option을 visible 처리할 수 없습니다. (등록된 option item이 없음)', {
              title: 'Notification',
              toaster: 'b-toaster-bottom-center',
              solid: true,
              appendToast: false,
              autoHideDelay: 1500,
              variant: 'danger'
            });
            return false;
          }
        }
      }
      return true;
    }
  }
})
</script>

<style>
span.required {
  color: red;
}

.image-title {
  display: block;
  margin-bottom: .3rem;
}

.image-box {
  display: block;
  max-width: 100%;
}

.hide-toolbar .ql-toolbar {
  display: none;
}

.hide-border .ql-container {
  border: none !important;
}

.custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

.custom-tags {
  height: 1.1rem !important;
}

#project-form .custom-input {
  height: 2em !important;
}

#project-form .dropdown-toggle {
  height: 2em !important;
  padding: 0 !important;
}

#project-form #tag-search-input {
  height: 2em;
  margin: 0;
}

#project-form .dropdown-item {
  height: 1.9rem;
  font-size: 0.8em !important;
}

#project-form #tags-with-dropdown {
  border: none;
  padding: 0 !important;
}

#project-form .b-dropdown-form {
  height: 3em;
}

#project-form #description {
  height: 4em;
}

#project-form .btn {
  width: 100%;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  /* background: #F6F6FA; */
  /* color: #AAA; */
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

/* 신규 스타일 Start */
/* 신규 추가 스타일 */
#project-form .btn-select-status .dropdown-toggle {
  position: relative;
  display: flex !important;
  align-items: center !important;
  gap: 0 0.933rem !important;
  min-height: 2.666rem;
  padding: 0.533rem 2.8rem 0.533rem 0.8rem !important;
  color: #1B1B1B;
  background-color: #FFF;
  font-family: 'NanumGothic' !important;
  font-size: 17px !important;
  font-weight: 400 !important;
  line-height: 42px !important;
}

#project-form .btn-select-status .dropdown-toggle:hover {
  background-color: #FFF;
}

#project-form .btn-select-status .dropdown-toggle:disabled:hover {
  background-color: #C4C4CD;
}

#project-form .badge-container .badge.open {
  background-color: #CFDDFF;
  color: #1755CC;
}

#project-form .btn-select-status .dropdown-toggle::after {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 0;
  content: "";
  border: none;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#project-form .card .card-body {
  margin-top: 0em;
  padding-top: 0%;
  padding-bottom: 1%;
}

#project-form .card .card-header {
  padding-left: 0;
  background-color: white !important;
  padding: 0;
  border-bottom: none !important;
}

#project-form .card #role-card-header,
#project-form .card #methodology-card-header {
  margin-bottom: 1em !important;
}

#project-form .card {
  margin-bottom: 2rem !important;
  border-radius: 30px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#project-form .card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
}

#project-form .card .card-body .card-body {
  padding: 0;
}

#project-form .card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

#project-form .card.description .card-body {
  padding: 0.666rem 0.666rem 1.666rem;
}

#project-form input.form-control {
  height: 40px !important;
  background-color: #FFF;
}

#project-form input[type="date"].form-control {
  padding: 8px 12px;
}

#project-form input#projectId {
  height: 45px !important;
  padding: 0;
  margin-bottom: 0;
  background-color: #FFF;
  border: none;
  color: #1B1B1B;
  font-family: 'NanumGothic';
  font-size: 30px;
  font-weight: 400;
  line-height: 150%;
}

#project-form input#projectId::placeholder {
  color: #AAA;
  font-size: 30px;
}

#project-form .project-id {
  display: inline-block;
  height: 2.5rem;
  margin-bottom: 1.333rem;
  padding: 0.4em;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  background-color: #F6F6FA;
  color: #2E2E38;
}

#project-form .form-control#title {
  height: 45px !important;
  padding: 0;
  background-color: transparent;
  border: none;
  font-weight: 700;
}

#project-form .form-control#title::placeholder {
  color: #AAA;
  font-size: 30px;
}

#project-form .btn-select-status .dropdown-toggle-original {
  display: flex;
  align-items: center;
  gap: 0 0.933rem;
  height: 100%;
  padding: 0.266rem 1.066rem 0.266rem 1.6rem;
  border: none;
  border-radius: 38px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}

#project-form .add-wrap .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

#project-form .add-wrap .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

#project-form .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

#project-form .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

#project-form .add-wrap .card.user {
  width: 33%;
  overflow: hidden;
}

#project-form .add-wrap .card.member {
  width: 67%;
  overflow: hidden;
}

#project-form .add-wrap {
  display: flex;
  gap: 0 2rem;
}

#project-form .add-wrap .card>.card-body {
  padding: 0;
}

#project-form .add-wrap .card .card-body .card-header {
  padding: 2rem 2.0833vw;
  border-radius: 30px 30px 0 0;
}

#project-form .add-wrap .card .card-body .card-body {
  padding: 0 2.0833vw;
  margin-bottom: 0.4rem;
  max-height: 40.333rem;
  min-height: 15.333rem;
  overflow-y: auto;
}

#project-form .b-form-tags .badge {
  display: inline-flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  line-height: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  height: 2em;
}

#project-form .description {
  border-radius: 13px !important;
  height: 4em;
  border: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  padding: 0.533rem 1.066rem;
}

#project-form .card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

#project-form .add-wrap .card-title-area .total-num,
#project-form .card-title-area .total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #FFE500;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}

#project-form .tag-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 0.666rem;
  margin-left: 1.333rem;
}

#project-form .tag-list::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translateY(-50%);
  width: 1px;
  height: 24px;
  background-color: #DDDDE3;
}

#project-form .b-form-tags .badge {
  gap: 0 0.666rem;
  height: 2.666rem;
  padding: 0.266rem 0.8rem 0.266rem 1.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  border-radius: 60px;
  border: 1px solid #DDDDE3;
  background-color: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#project-form label {
  font-family: 'NanumGothic';
}

#project-form .title-wrap .input-wrap:first-child {
  min-width: 393px;
  flex-shrink: 0;
}

#project-form .project-form-wrap {
  display: flex;
  gap: 2rem;
  margin-top: 2.666rem;
}

#project-form .project-form-wrap .input-wrap {
  display: flex;
  flex-direction: column;
}

#project-form .project-form-wrap .left-form-area {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  min-width: 393px;
  flex-shrink: 0;
}

#project-form .project-form-wrap .left-form-area .date-wrap {
  display: flex;
  gap: 0 1.333rem;
}

#project-form .project-form-wrap .date-wrap .form-group {
  width: calc(50% - 10px);
}

#project-form .project-form-wrap .date-wrap .form-group:first-child {
  position: relative;
}

#project-form .project-form-wrap .date-wrap .form-group:first-child::after {
  content: '~';
  display: block;
  position: absolute;
  top: 50%;
  right: -15px;
  transform: translateY(-50%);
  color: #747480;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#project-form .project-form-wrap .date-wrap .custom-input {
  height: 2.666rem !important;
  background-color: #FFF;
}

#project-form .project-form-wrap .right-form-area {
  flex-grow: 1;
  flex-shrink: 0;
}

#project-form .input-wrap.border-bottom {
  padding-bottom: 20px;
  border-bottom: 1px solid #DDDDE3;
}

#project-form .input-wrap.title {
  flex-grow: 1;
  flex-shrink: 0;
}

#project-form .project-tab-card .card-header {
  border-radius: 20px 20px 0 0;
}

#project-form .project-tab-card .card-header-tabs {
  gap: 0 30px;
  padding: 20px 0 0;
  margin: 0 40px;
  border-bottom: 1px solid #DDDDE3;
}

#project-form .project-tab-card .nav-tabs .nav-item {
  margin-bottom: 0;
}

#project-form .project-tab-card .nav-tabs .nav-link {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

#project-form .project-tab-card .nav-tabs .nav-link.active,
#project-form .project-tab-card .nav-tabs .nav-item.show .nav-link {
  color: #2E2E38;
  font-weight: 700;
  border-bottom: 3px solid #2E2E38;
}

#project-form .project-tab-card .nav-tabs .nav-link.disabled {
  color: #C4C4CD;
}

#project-form .project-tab-card .tab-content {
  padding: 40px 2.0833vw;
}

#project-form .card .card-body.tab-pane {
  padding: 0;
}

#project-form .project-tab-card .custom-select {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

#project-form .project-tab-card .methodology-select {
  max-width: 328px;
}

#project-form .project-tab-card .custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

#project-form .project-tab-card .btn-clear {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: rgba(255, 0, 0, 0.10);
  color: #F00;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

#project-form .project-tab-card .btn-clear:hover {
  color: #F00;
}

#project-form .project-tab-card .roles-wrap {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
}

#project-form .project-tab-card .roles-wrap .btn-black {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  height: 40px !important;
  padding: 0.266rem 1.6rem 0.266rem 0.8rem !important;
  color: #FFF;
  border: none;
  border-radius: 60px;
  background-color: #2E2E38;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#project-form .project-tab-card .roles-wrap .btn-black .icon.plus {
  display: block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 10H15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 15L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu {
  min-width: 33.3rem;
  margin-top: 10px;
  padding: 20px;
  border-radius: 20px;
  border: none;
  background-color: #FFF;
  box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form {
  padding: 0;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row {
  margin: 0;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row label {
  padding: 0;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row>.col {
  padding: 0;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-divider {
  display: none;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-item {
  height: 36px;
  padding: 6px 10px;
  border-radius: 10px;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px !important;
  font-weight: 500;
  line-height: 150%;
}

#project-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-item:hover {
  background-color: #F6F6FA;
  color: #2E2E38;
  font-weight: 700;
}

#project-form .project-tab-card .members-wrap {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

#project-form .project-tab-card .members-wrap .members-content {
  position: relative;
  padding: 2rem 1.5625vw;
  border-radius: 20px;
  border: 1px solid #DDDDE3;
}

#project-form .project-tab-card .members-wrap .members-content.users {
  width: 36%;
  overflow: hidden;
}

#project-form .project-tab-card .members-wrap .members-content.members {
  width: 64%;
}

#project-form .project-tab-card .members-wrap .members-content .title {
  height: 60px;
  color: #000;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
}

#project-form .project-tab-card .members-wrap .members-content.users .btn-assign {
  position: absolute;
  top: 20px;
  right: 30px;
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background-color: #747480;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.file-input-area {
  padding: 2em 2.2em 0em 2.2em;
}

.file-input-area .file-input-area_button {
  width: 30%;
  margin: 0 0.3em;
  border-radius: 10px;
  border: none;
  font-family: 'NanumGothic';
  background-color: rgb(246, 246, 250);
}

.file-input-area .file-input-area_button:last-child {
  margin-left: 1.5em;
}

.card.file .card-body {
  padding: 2.666rem 2.0833vw;
}

.new-file-label label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 0px;
}

.new-file-label>div {
  height: 100%;
}

.new-file-input .custom-file-input {
  height: 100%;
}

.new-file-input .custom-file-input~.custom-file-label[data-browse]::after {
  content: none;
}

.new-file-input .custom-file-input.focus {
  border: none;
  box-shadow: none;
}

.new-file-input label.custom-file-label {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 1.333rem 0;
  margin-bottom: 0;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
}

.new-file-input label.custom-file-label:hover {
  border-color: #2E2E38;
  cursor: pointer;
}

.new-file-input .custom-file-label span {
  padding-left: 30px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
  background-position: 0 center;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.new-file-input .custom-file-label:hover span {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  color: #2E2E38;
}

.new-file-input .custom-file-input:focus~.custom-file-label {
  border-color: #2E2E38;
  box-shadow: none;
}

.table-wrap .table thead {
  background-color: transparent;
}

.table-wrap {
  margin-top: 2rem;
  border-radius: 10px;
  border: 1px solid #DDDDE3;
}

.table-wrap .table .thead-light th {
  padding: 0.666rem;
  border-bottom: 1px solid #DDDDE3;
  background-color: #F6F6FA;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.table-wrap .table.b-table>tbody>.table-active,
.table-wrap .table.b-table>tbody>.table-active>td {
  background-color: transparent;
}

.table-wrap .table.b-table.table-hover>tbody>tr.table-active:hover td {
  background-image: none;
}

.table-wrap .table tr td {
  padding: 0.666rem;
  border-bottom: 1px solid #E7E7EE;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.table-wrap .table tr:last-child td {
  border-bottom: none;
}

.columnRate10 {
  width: 10%;
}

.columnRate11 {
  width: 11%;
}

.columnRate13 {
  width: 13%;
}

.columnRate20 {
  width: 20%;
}

.columnRate48 {
  width: 48%;
}

.add-item-button {
  height: 41px !important;
  width: 65px !important;
}

.add-item-input-group {
  display: flex;
  justify-content: space-around;
  gap: 2rem;
}

.config-option-item {
  margin: 0.2rem 0.3rem 0.2rem 0.3rem;
  padding: 0.4rem 1rem 0.4rem 1rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  border-radius: 60px;
  border: 1px solid #DDDDE3;
  background-color: #F6F6FA;
}

.config-option-item-default {
  margin: 0.2rem 0.3rem 0.2rem 0.3rem;
  padding: 0.4rem 1rem 0.4rem 1rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  border-radius: 60px;
  border: 1px solid #DDDDE3;
  background-color: #e3e3e5;
}

.config-option-items {
  display: -webkit-box;
  overflow-x: auto;
}

/* 신규 스타일 END */

.config-row {
  height: 4.5em;
}
</style>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.timeline-empty {
  text-align: center;
  font-family: 'NanumGothic';
  color: grey;
  background-color: rgb(250, 250, 250);
  border-radius: 10px;
  padding: 3em;
}

.import-button-area {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.4em;
}
</style>
